import React, { useContext, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import MainContext from '../../context/mainContext';
import http from '../../services/httpService';
import socket from '../../services/socketService';
import { getQueries } from '../../utils/helpers';
import useDocumentTitle from './../../hooks/useDocumentTitle';
import useMain from './../../hooks/useMain';
import Anchor from './../common/anchor';
import Image from './../common/image';
import LoginForm from './loginForm';
import OTPForm from './otpForm';

const Login = (props) => {
	useDocumentTitle(['Login']);
	const { theme } = useMain();
	const { email } = getQueries();
	const { onUserDataChanged } = useContext(MainContext);
	const [isLoading, setIsLoading] = useState(false);
	const [needsOTP, setNeedsOTP] = useState(false);
	const [credentials, setCredentials] = useState(null);

	const { state } = props.location;
	const prevPath = state && state.from ? state.from.pathname : '/';

	const doSubmit = async (formData) => {
		try {
			setIsLoading(true);
			const { data, headers } = await http.login({
				email: formData.email.trim(),
				password: formData.password.trim(),
			});
			if (data === 'otp') {
				setNeedsOTP(true);
				setCredentials({
					email: formData.email.trim(),
					password: formData.password.trim(),
				});
			} else {
				onUserDataChanged(data);
				socket.submitSocket(data._id, data.email);
				http.setJwt(headers['x-auth-token']);
			}
			setIsLoading(false);
		} catch (ex) {
			console.log(ex);
			setIsLoading(false);
			if (ex && ex.response && ex.response.data) return toast.error(ex.response.data);
			if (ex && ex.message) return toast.error(ex.message);
		}
	};

	const doOTPSubmit = async (formData) => {
		try {
			setIsLoading(true);
			const { data, headers } = await http.loginOTP({
				email: credentials.email.trim(),
				password: credentials.password.trim(),
				token: formData.token,
			});
			onUserDataChanged(data);
			socket.submitSocket(data._id, data.email);
			http.setJwt(headers['x-auth-token']);
			setIsLoading(false);
		} catch (ex) {
			console.log(ex);
			setIsLoading(false);
			if (ex && ex.response && ex.response.data) return toast.error(ex.response.data);
			if (ex && ex.message) return toast.error(ex.message);
		}
	};

	if (http.getCurrentUser()) return <Redirect to={prevPath} />;
	return (
		<main className='loginPage centerAll'>
			<div className='container'>
				<div className='row'>
					<div className='col-lg-4 offset-lg-4 col-12'>
						<div className='card loginCard'>
							<div className='card-body'>
								<div className='text-center'>
									<Link to='/'>
										<Image
											className='w-100 my-4 px-5'
											fileName={`logo/${theme}.webp`}
										/>
									</Link>
									<h1>Login</h1>
								</div>

								{needsOTP ? (
									<OTPForm
										theme={theme}
										email={email}
										isLoading={isLoading}
										onSubmit={doOTPSubmit}
									/>
								) : (
									<LoginForm
										theme={theme}
										email={email}
										isLoading={isLoading}
										onSubmit={doSubmit}
									/>
								)}

								<p className='text-center mt-4'>
									Don't you have account? Please{' '}
									<Anchor
										className={`defaultLink text-set3-${theme}`}
										content='register'
										href='https://bemchain.io'
									/>{' '}
									now.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default Login;
